(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fit-confidence-guide"] && !Shopify.designMode) return;
  try {
    
(() => {
  try {
    const previous = sessionStorage.getItem('chisos-fit-return');
    if (!previous) return;
    const url = new URL(previous);
    if (url.origin !== location.origin || url.pathname !== '/products/chisos-no-2' || url.searchParams.get('view') !== 'boots-2026-09') return;
    document.querySelectorAll('[data-fc-return]').forEach(link => {link.href = url.href;});
  } catch (error) {}
})();

  } catch(e) { console.error(e); }
})();
})();
